export enum AppRoutes {
    CONFIRM = 'confirm',
    APPS = 'apps',
    APPLICATION = 'applications',
    BROWSER = 'browsers',
}
